import React from "react";

function BS4_AllClasses() {
  return (
    <div>
      <h1>BS4_AllClasses Component</h1>
      <p>This is the BS4_AllClasses tutorial page content.</p>
    </div>
  );
}

export default BS4_AllClasses;
